import { Formik } from 'formik';
import * as Yup from 'yup';

import { io, snakeToTitleCase } from 'lib/helpers/utility';

import useUpsertMacro from '../hooks/useUpsertMacro';

import UpsertModalForm from './components/Forms/UpsertModalForm';
import UpsertModal from './components/UpsertModal';

const UpsertMacro = ({
  macroType,
  open,
  handleClose,
  isModal = true,
  isEditing = false,
  loading,
  className,
  footer
}) => {
  const macroTitle = snakeToTitleCase(macroType);

  const content = <UpsertModalForm macroType={macroType} footer={footer} />;

  if (!isModal) return content;

  return (
    <UpsertModal
      open={open}
      macroTitle={macroTitle}
      loading={loading}
      className={className}
      closeHandler={handleClose}
      isEditing={isEditing}>
      {content}
    </UpsertModal>
  );
};

const UpsertMacroWrapper = ({
  macro = null,
  macroType,
  open,
  handleClose,
  isModal = true,
  customMacroBody = {},
  className,
  footer
}) => {
  const macroValidationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    ...(macroType === 'text_macro' && {
      body: Yup.string().required('Content is required')
    })
  });

  const formMacroBody =
    macroType === 'form_macro' && io(macro?.body) ? macro.body : customMacroBody;
  const { upsert, loading } = useUpsertMacro({ macroType, customMacroBody: formMacroBody });

  const handleUpsert = async (values, helpers) => {
    await upsert(values);
    handleClose();
    helpers.resetForm();
  };

  return (
    <Formik
      initialValues={{
        ...(macro || {}),
        name: macro?.name ?? '',
        body: macro?.body ?? ''
      }}
      enableReinitialize
      validationSchema={macroValidationSchema}
      validateOnChange
      onSubmit={handleUpsert}>
      <UpsertMacro
        {...{
          macroType,
          open,
          handleClose,
          loading,
          isModal,
          isEditing: !!macro,
          className,
          footer
        }}
      />
    </Formik>
  );
};

export default UpsertMacroWrapper;
